/* globals $ */
(function() {
	'use strict';

	angular.module('quantixApp').directive('autocomplete', autocomplete);

	function autocomplete() {
		var index = -1;
		var directive = {

			restrict : 'E',
			scope : {
				searchParam : '=ngModel',
				suggestions : '=data',
				onType : '=onType',
				onSelect : '=onSelect',
				filterLength : '=maxfilterlength',
//				autocompleteRequired : '=',
				// noAutoSort: '=noAutoSort',
				getUrl : '=getUrl'
			},

			controller : [
					'$scope',
					function($scope) {
						// the index of the suggestions that's currently selected
						$scope.selectedIndex = -1;
						//dis is used for tesing of ng-show or hide of icon when url is not present 

						$scope.testData = null;
						$scope.initLock = true;
						// set new index
						$scope.setIndex = function(i) {
							$scope.selectedIndex = parseInt(i);
						};

						this.setIndex = function(i) {
							$scope.setIndex(i);
							$scope.$apply();
						};

						$scope.getIndex = function(i) {
							return $scope.selectedIndex;
						};

						// watches if the parameter filter should be changed
						var watching = true;

						// autocompleting drop down on/off
						$scope.completing = false;

						//alert("Filter Length:"+$scope.filterLength);
						// starts autocompleting on typing in something
						$scope
								.$watch(
										'searchParam',
										function(newValue, oldValue) {
											var regex = /^[a-zA-Z -_]*$/;
										 
											if (oldValue === newValue
													|| (!oldValue && $scope.initLock)) {
												return;
											}
											if(!regex.test(newValue)){    
													$scope.notMatchedRegex=true;
											}else if(regex.test(newValue)){
												$scope.notMatchedRegex=false;
											}

											if (watching
													&& typeof $scope.searchParam !== 'undefined'
													&& $scope.searchParam !== null) {
												$scope.completing = true;
												$scope.searchFilter = $scope.searchParam;
												$scope.selectedIndex = -1;

												if((typeof $scope.filterLength != 'undefined' && newValue.length >= $scope.filterLength) 
												|| (typeof $scope.filterLength == 'undefined'  &&  newValue.length >= 3)
												){
	                                         // function thats passed to on-type attribute gets executed
                                      	if ($scope.onType)
                                	$scope .onType($scope.searchParam);
												}	else {
											 		$scope.onType("cleanData");//clean suggestion list below three characters
													$scope.completing = false;
												}
											}
										});

						// for hovering over suggestions
						this.preSelect = function(suggestion) {

							watching = false;

							// this line determines if it is shown
							// in the input field before it's selected:
							//$scope.searchParam = suggestion;

							$scope.$apply();
							watching = true;

						};

						$scope.preSelect = this.preSelect;

						this.preSelectOff = function() {
							watching = true;
						};

						$scope.preSelectOff = this.preSelectOff;

						// selecting a suggestion with RIGHT ARROW or ENTER
						$scope.select = function(suggestion) {
							watching = false;
							if (suggestion) {
								$scope.searchParam = suggestion.companyName;
								$scope.searchFilter = suggestion.companyName;

								if ($scope.onSelect)
									$scope.onSelect(suggestion);
							}
							watching = false;
							$scope.completing = false;
							setTimeout(function() {
								watching = true;
							}, 1000);
							$scope.setIndex(-1);
						};
						
						$scope.selectComp = function(suggestion) {
							watching = false;
							if (suggestion) {
								$scope.searchParam = '';
								$scope.searchFilter = suggestion.companyName;

								if ($scope.onSelect)
									$scope.onSelect(suggestion);
							}
							watching = false;
							$scope.completing = false;
							setTimeout(function() {
								watching = true;
							}, 1000);
							$scope.setIndex(-1);
						};
						
						$scope.redirectFinancial = function(suggestion,section) {
							watching = false;
							if (suggestion) {
								$scope.searchParam = suggestion.companyName;
								$scope.searchFilter = suggestion.companyName;

								if ($scope.onSelect)
									$scope.onSelect(suggestion,section);
							}
							watching = false;
							$scope.completing = false;
							setTimeout(function() {
								watching = true;
							}, 1000);
							$scope.setIndex(-1);
						};
					}],
			link : function(scope, element, attrs) {
				scope.getUrl = 'app/common/directives/autoComplete'
						+ attrs.getUrl;

				setTimeout(function() {
					scope.initLock = false;
					scope.$apply();
				}, 250);

				var attr = '';

				// Default atts
				scope.attrs = {
					"placeholder" : "Search....",
					"class" : "",
					"id" : "",
					"inputclass" : "",
					"inputid" : ""
				};

				for ( var a in attrs) {
					attr = a.replace('attr', '').toLowerCase();
					// add attribute overriding defaults
					// and preventing duplication
					if (a.indexOf('attr') === 0) {
						scope.attrs[attr] = attrs[a];
					}
				}

				if (attrs.clickActivation) {
					element[0].onclick = function(e) {
						if (!scope.searchParam) {
							setTimeout(function() {
								scope.completing = true;
								scope.$apply();
							}, 200);
						}
					};
				}

				var key = {
					left : 37,
					up : 38,
					right : 39,
					down : 40,
					enter : 13,
					esc : 27,
					tab : 9,
					backspace : 8,
					del : 46
				};

				document.addEventListener("keydown", function(e) {
					var keycode = e.keyCode || e.which;

					switch (keycode) {
					case key.esc:
						// disable suggestions on escape
						scope.select();
						scope.setIndex(-1);
						scope.$apply();
						e.preventDefault();
					}
				}, true);

				document.addEventListener("blur", function(e) {
					// disable suggestions on blur
					// we do a timeout to prevent hiding it before a click event is registered
					setTimeout(function() {
						scope.select();
						scope.setIndex(-1);
						scope.$apply();
					}, 150);
				}, true);

				element[0]
						.addEventListener(
								"keydown",
								function(e) {
									var keycode = e.keyCode || e.which;

									var l = angular.element(this).find('li').length;

									// this allows submitting forms by pressing Enter in the autocompleted field
									if (!scope.completing || l == 0)
										return;

									// implementation of the up and down movement in the list of suggestions
									switch (keycode) {
									case key.up:

										index = scope.getIndex() - 1;
										if (index < -1) {
											index = l - 1;
										} else if (index >= l) {
											index = -1;
											scope.setIndex(index);
											scope.preSelectOff();
											break;
										}
										scope.setIndex(index);

										if (index !== -1)
											scope.preSelect(angular.element(
													angular.element(this).find(
															'li')[index])
													.text());

										scope.$apply();

										break;
									case key.down:
										index = scope.getIndex() + 1;
										if (index < -1) {
											index = l - 1;
										} else if (index >= l) {
											index = -1;
											scope.setIndex(index);
											scope.preSelectOff();
											scope.$apply();
											break;
										}
										scope.setIndex(index);

										if (index !== -1)
											scope.preSelect(angular.element(
													angular.element(this).find(
															'li')[index])
													.text());

										break;
									case key.left:
										break;
									case key.right:
									case key.enter:
									case key.tab:

										index = scope.getIndex();
										// scope.preSelectOff();
										if (index !== -1) {
											//get json object from html element - selection from filtered list on press of enter key
											// scope.select(JSON.parse(angular.element(angular.element(this).find('li')[index]).context.attributes[4].value));
											scope
													.select(JSON
															.parse(angular
																	.element(angular
																			.element(
																					this)
																			.find(
																					'li')[index])[0].attributes[4].value));
											if (keycode == key.enter) {
												e.preventDefault();
											}
										} else {
											if (keycode == key.enter) {
												scope.select();
											}
										}
										scope.setIndex(-1);
										scope.$apply();

										break;
									case key.esc:
										// disable suggestions on escape
										scope.select();
										scope.setIndex(-1);
										scope.$apply();
										e.preventDefault();
										break;
									default:
										return;
									}

								});
			},

			templateUrl : function(elem, attrs) {
				return 'app/common/directives/autoComplete/' + attrs.getUrl;
			}

		};

		return directive;
	}
})();
